import { render } from "./TextPage.vue?vue&type=template&id=47e832b4&ts=true"
import script from "./TextPage.vue?vue&type=script&lang=ts"
export * from "./TextPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__